import comp from "./CreateAccount";
export default comp;
